import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from 'syf-component-library/ui/spacing';
import OptionList from './OptionList';
var Chip = function (_a) {
    var answer = _a.answer;
    var answerOptions = answer.answerOptions;
    return (_jsxs(_Fragment, { children: [_jsx(Stack, { size: "medium" }), _jsx(OptionList, { answerOptions: answerOptions })] }));
};
export default Chip;
//# sourceMappingURL=index.js.map